import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import api from "../../api";
import { useAlert } from "react-alert";
import userAction from "../../redux/users/action";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { BeforePayTerms } from "../modals/beforePayTermsModal";
import { TextPopupModal } from "../modals/textPopup";
import trendMeter from "../../images/trendMeter.png";
import arc from "../../images/Arc1.png";
import { VideoModalDashboard } from "../modals/videoModal";
import Stepper from "../dashboardComp/progressBar";
import "./checkout.css";
// import { BeforePayTermsBt } from "../modals/beforePayTermsBtModal";

export const Checkout = ({ SubsData }) => {
  const alert = useAlert();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setUser } = userAction;
  const userStore = useSelector((state) => state.userReducer);
  const [loader, setLoader] = useState(true);
  const [isSubscription, setIsSubscription] = useState(false);
  const [trendData, setTrendData] = useState({});
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [popupText, setPopupText] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const handleClosePopup = () => setShowPopup(false);
  const handleShowPopup = () => setShowPopup(true);

  const [showVideo, setShowVideo] = useState(false);
  const handleCloseVideo = () => setShowVideo(false);
  const handleShowVideo = () => setShowVideo(true);

  const [stripeStatus, setStripeStatus] = useState("");
  const [showNotice, setShowNotice] = useState(true);

  const onStripePay = async () => {
    try {
      setLoader(true);
      if (!userStore?.users?.user?._id) {
        setLoader(false);
        alert.show("User not found");
        return;
      }
      if (isSubscription) {
        setLoader(false);
        alert.show("Already Subscribed");
        return;
      }
      const userCansubscribe = await checkCanSubscribe();
      // console.log(userCansubscribe);
      if (userCansubscribe?.canSubscribe) {
        const payload = {
          _id: userStore?.users?.user?._id,
          item: 1,
          months: 1,
        };
        const stripeRes = await api.createPayment(payload);

        if (!stripeRes?.link) {
          throw new Error("Something went wrong");
        }

        window.open(stripeRes?.link, "_self");
      } else {
        if (userCansubscribe?.status) {
          if (userCansubscribe?.status.toLowerCase() == "active") {
            setPopupText(
              "YOU ALREADY HAVE ACTIVE SUBSCRIPTION. PLEASE CREATE A TICKET TO CONTACT OUR SUPPORT TEAM.",
            );
          } else if (userCansubscribe?.status.toLowerCase() == "past_due")
            setPopupText(
              `YOU ALREADY HAVE A SUBSCRIPTION, YOUR RECURRING PAYMENT IS PENDING.`,
            );
        } else {
          setPopupText(`PLEASE CREATE A TICKET TO CONTACT OUR SUPPORT TEAM.`);
        }
        handleShowPopup();
      }
      setLoader(false);
    } catch (e) {
      alert.show(e.message);
      setLoader(false);
    }
  };

  const editSubs = async () => {
    try {
      setLoader(true);
      if (!userStore?.users?.user?._id) {
        alert.show("User not found");
      }
      const payload = {
        _id: userStore?.users?.user?._id,
      };
      const stripeRes = await api.editPayment(payload);
      // console.log(stripeRes);

      if (!stripeRes?.link) {
        throw new Error("Something went wrong");
      }

      window.open(stripeRes?.link, "_blank");
      setLoader(false);
    } catch (e) {
      // No such subscription:
      console.log(e);
      alert.show(e.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    if (userStore?.users?.user?._id) {
      // checkSubs();
      setLoader(false);
    }
    setIsSubscription(SubsData?.isSubscription || false);
  }, [userStore?.users, SubsData]);

  const checkSubsStatus = async () => {
    try {
      setLoader(true);
      const stripeRes = await api.getSubscriptionStatus(
        userStore?.users?.user?.email,
      );
      // console.log(stripeRes);
      if (stripeRes?.status) {
        setStripeStatus(stripeRes?.status);
      }

      setLoader(false);
    } catch (e) {
      console.log(e);

      alert.show(e.message);
      setLoader(false);
    }
  };

  const checkCanSubscribe = async () => {
    try {
      const stripeRes = await api.getCanSubscribe(
        userStore?.users?.user?.email,
      );
      return stripeRes;
    } catch (e) {
      alert.show(e.message);
      setLoader(false);
    }
  };

  const getMarketTrend = async () => {
    try {
      const resp = await api.getMarketTrend();
      // console.log(resp);
      if (resp?.marketTrend?.trend_score) {
        setTrendData({
          trend_score: resp?.marketTrend?.trend_score,
          buy_pressure: resp?.marketTrend?.buy_pressure,
          sell_pressure: resp?.marketTrend?.sell_pressure,
        });
      }
    } catch (e) {
      console.log(e.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    // console.log(userStore?.users?.user?.email);

    if (userStore?.users?.user?.email && SubsData?._id) {
      let currentDate = new Date();
      let endDate = new Date(SubsData?.nextPayment);
      if (currentDate > endDate) {
        checkSubsStatus();
      }
    }
    if (userStore?.users?.user?.email) {
      // getMarketTrend();
    }
  }, [userStore, SubsData]);

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <div className="container">
        <Stepper SubsData={SubsData} />

        <div className="row">
          <div className="col-12">
            {showNotice && isSubscription && (
              <div className="noticeAlert">
                <div className="closeIcon" onClick={() => setShowNotice(false)}>
                  <i className="fa-solid fa-xmark" />
                </div>
                <div className="alert alert-primary" role="alert">
                  📢 Welcome to WaqarZaka Platform. To get started, please watch
                  the Onboarding Video. It will guide you on how to use the
                  platform, navigate features, and begin your learning and
                  trading journey.
                  <div>
                    <button
                      className="themeBlackBtn mt-1"
                      onClick={handleShowVideo}
                    >
                      WATCH NOW
                    </button>
                  </div>
                </div>
              </div>
            )}
            <div
              className={
                showNotice ? "ckpCheckout mt-0" : "ckpCheckout"
              }
            >
              <div className="ckp-orb o1"></div>
              <div className="ckp-orb o2"></div>
              <div className="ckp-wrap">
                <div className="ckp-grid">
                  {/* LEFT: value panel */}
                  <div className="ckp-panel">
                    <div className="ckp-hero">
                      <div className="ckp-hero-inner">
                        <div className="ckp-tag">Education First</div>
                        <h2 className="ckp-h1">
                          We Are an <span>Educational</span> Platform
                        </h2>
                        <p>
                          Learn how we invest, what we are watching next, and
                          the research behind every decision.
                        </p>
                      </div>
                    </div>
                    <div className="ckp-groups">
                      <div className="ckp-group">
                        <div className="ckp-group-head">
                          <span
                            className="ckp-gi"
                            style={{ color: "#895aef", background: "#f2eefe" }}
                          >
                            &#9670;
                          </span>
                          <h3>What We Are Invested In</h3>
                        </div>
                        <div className="ckp-items">
                          <div className="ckp-benefit">
                            <span className="tick" style={{ color: "#895aef" }}>
                              &#10003;
                            </span>
                            <span>
                              Get exclusive access to our current investments
                              in crypto projects.
                            </span>
                          </div>
                          <div className="ckp-benefit">
                            <span className="tick" style={{ color: "#895aef" }}>
                              &#10003;
                            </span>
                            <span>
                              Track our portfolio performance and see what’s
                              working.
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="ckp-group">
                        <div className="ckp-group-head">
                          <span
                            className="ckp-gi"
                            style={{ color: "#2563eb", background: "#e8f0fe" }}
                          >
                            &#9678;
                          </span>
                          <h3>Where We Are Going to Invest</h3>
                        </div>
                        <div className="ckp-items">
                          <div className="ckp-benefit">
                            <span className="tick" style={{ color: "#2563eb" }}>
                              &#10003;
                            </span>
                            <span>
                              Stay ahead with our future investment plans
                              before anyone else.
                            </span>
                          </div>
                          <div className="ckp-benefit">
                            <span className="tick" style={{ color: "#2563eb" }}>
                              &#10003;
                            </span>
                            <span>
                              Leverage our in-depth market analysis and
                              research-backed decisions.
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="ckp-group">
                        <div className="ckp-group-head">
                          <span
                            className="ckp-gi"
                            style={{ color: "#059669", background: "#e6f7f0" }}
                          >
                            &#9632;
                          </span>
                          <h3>What You Get</h3>
                        </div>
                        <div className="ckp-items">
                          <div className="ckp-benefit">
                            <span className="tick" style={{ color: "#059669" }}>
                              &#10003;
                            </span>
                            <span>
                              Insider insights into top crypto projects.
                            </span>
                          </div>
                          <div className="ckp-benefit">
                            <span className="tick" style={{ color: "#059669" }}>
                              &#10003;
                            </span>
                            <span>
                              Real-time investment strategies from experienced
                              traders.
                            </span>
                          </div>
                          <div className="ckp-benefit">
                            <span className="tick" style={{ color: "#059669" }}>
                              &#10003;
                            </span>
                            <span>
                              Exclusive research reports on market trends and
                              opportunities.
                            </span>
                          </div>
                          <div className="ckp-benefit">
                            <span className="tick" style={{ color: "#059669" }}>
                              &#10003;
                            </span>
                            <span>
                              Community discussions and expert opinions.
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* RIGHT: checkout card */}
                  <div className="ckp-card">
                    <div className="ckp-price-head">
                      <div className="ckp-chip-row">
                        <span className="ckp-chip-a">Subscription</span>
                        <span className="ckp-chip-b">Cancel anytime</span>
                      </div>
                      <div className="ckp-amount">
                        <b>$10</b>
                        <i>/ month</i>
                      </div>
                      <p>
                        Monthly recurring subscription. You’ll be charged
                        automatically after <strong>30 Days</strong>{" "}
                        completed.
                      </p>
                    </div>

                    <div className="ckp-form">
                      <label className="ckp-label">Billing Email</label>
                      <input
                        className="ckp-input"
                        type="email"
                        value={userStore?.users?.user?.email}
                        disabled
                      />

                      {SubsData?._id &&
                        !loader &&
                        !SubsData?.unSubscribeReason && (
                          <>
                            {SubsData?.subscribeVia != "braintree" && (
                              <p className="ckp-note">
                                Do you want to change your billing details or
                                retry payment?{" "}
                                <span onClick={editSubs} className="ckp-link">
                                  Click Here
                                </span>{" "}
                              </p>
                            )}
                          </>
                        )}
                      {isSubscription &&
                      !loader &&
                      !SubsData?.unSubscribeReason ? (
                        <button className="ckp-pay is-static">
                          <span className="label">Already Subscribed</span>
                        </button>
                      ) : isSubscription && SubsData?.unSubscribeReason ? (
                        <button className="ckp-pay is-static">
                          <span className="label">
                            Subscription is active till{" "}
                            {formatDate(SubsData?.nextPayment)}
                          </span>
                        </button>
                      ) : SubsData?._id &&
                        !SubsData?.isSubscription &&
                        !loader &&
                        !SubsData?.unSubscribeReason &&
                        stripeStatus.includes("No subscription") ? (
                        <button className="ckp-pay" onClick={handleShow}>
                          <span className="shine"></span>
                          <span className="label">PAY NOW</span>
                        </button>
                      ) : loader ? (
                        <button className="ckp-pay is-static">
                          <i
                            className="fa fa-spinner fa-pulse mx-2 mb-1"
                            style={{ position: "relative", top: "-0px" }}
                          ></i>
                          <span className="label">loading</span>
                        </button>
                      ) : SubsData?._id &&
                        !SubsData?.isSubscription &&
                        !loader &&
                        !SubsData?.unSubscribeReason ? (
                        <>
                          <button className="ckp-pay is-static">
                            <span className="label">
                              Recurring Payment Pending
                            </span>
                          </button>
                          <div className="ckp-cancel-note">
                            Do you want to cancel your Subscription?{" "}
                            <span
                              onClick={() => navigate("/subscription/history")}
                              className="ckp-link"
                            >
                              Click Here
                            </span>
                          </div>
                        </>
                      ) : (
                        <button className="ckp-pay" onClick={handleShow}>
                          <span className="shine"></span>
                          <span className="label">PAY NOW</span>
                        </button>
                      )}

                      <div className="ckp-secure">
                        <span>&#128274;</span>
                        <span>Secure encrypted checkout</span>
                      </div>

                      <div className="ckp-assure">
                        <div>
                          <span className="m">&#10003;</span>
                          <span>Instant dashboard access after payment</span>
                        </div>
                        <div>
                          <span className="m">&#10003;</span>
                          <span>Cancel anytime from your account</span>
                        </div>
                        <div>
                          <span className="m">&#10003;</span>
                          <span>
                            Educational content, not financial advice
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BeforePayTerms
        show={show}
        handleShow={handleShow}
        handleClose={handleClose}
        onStripePay={onStripePay}
      />
      <TextPopupModal
        show={showPopup}
        handleClose={handleClosePopup}
        text={popupText}
      />
      <VideoModalDashboard show={showVideo} handleClose={handleCloseVideo} />
    </>
  );
};
